module.exports = __webpack_public_path__ + "img/Most-Critical@3x.fb6d3590.png";